export default "__VITE_ASSET__CFdb7BSr__"